import { merchantGroupSchema } from "../../../shared/merchantGroupSchema";
import { z } from "zod";
import {
  allowedPeriodSchema,
  categoryItemSchema,
  countryCodeSchema,
  typeLimitSchema,
} from "../_shared";

export const updateRulePayloadSchema = z
  .object({
    name: z.string(),
    onlyFrance: z.boolean(),
    nationalHolidays: z.boolean(),
    amountLimit: z.int(),
    typeLimit: typeLimitSchema,
    allowedCountries: z.array(countryCodeSchema),
    areOtherMerchantsAuthorized: z.boolean(),
    areSupportingDocumentsMandatory: z.boolean(),
    unauthorizedMerchantGroups: z.array(merchantGroupSchema),
    allowedPeriods: z.array(allowedPeriodSchema).optional(),
    categories: z.array(categoryItemSchema),
    canPayOnline: z.boolean(),
  })
  .strict();

export type UpdateRulePayload = z.infer<typeof updateRulePayloadSchema>;
